export const MobileAppConvenienceSheetTexts = {
  title: 'В приложении удобнее',
  firstParagraph:
    'Приложение Сравни показывает МФО, которые с наибольшей вероятностью одобрят нужную сумму именно вам.',
  secondParagraph:
    'Анкету заполняете один раз — не нужно переходить на сайты разных МФО и заполнять её заново для каждой заявки.',
  thirdParagraph:
    'Все предложения без скрытых комиссий и страховок, условия уже финальные и одобрены для вас. Выберите подходящее и получите деньги на карту.',
  badge: 'Оформление займа полностью внутри приложения — от заполнения анкеты до получения денег проходит 10 минут',
  downloadApp: 'Скачать приложение',
  continueInWebsite: 'Продолжить на сайте',
};
